/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sage_Wry_Lark_RaceInputs */

const en_sage_wry_lark_race = /** @type {(inputs: Sage_Wry_Lark_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firstname`)
};

const de_sage_wry_lark_race = /** @type {(inputs: Sage_Wry_Lark_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "Firstname" |
*
* @param {Sage_Wry_Lark_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_wry_lark_race = /** @type {((inputs?: Sage_Wry_Lark_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Wry_Lark_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_wry_lark_race(inputs)
	return de_sage_wry_lark_race(inputs)
});